import { parseInTz } from 'helpers/date';
import { constructURL } from 'helpers/url';
import ApplicationController from './application_controller';

export default class extends ApplicationController {
  static targets = ['recordsAjaxSelect'];

  dateTimeOfServiceChanged(event) {
    const dateOfService = parseInTz(event.target.value).format();
    const url = constructURL(this.recordsAjaxSelectTarget.getAttribute('src'), { date_of_service: dateOfService });
    this.recordsAjaxSelectTarget.setAttribute('src', url.toString());
  }

  patientChanged(event) {
    const patientID = event.target.value;
    const url = constructURL(this.recordsAjaxSelectTarget.getAttribute('src'), { patient_id: patientID });
    this.recordsAjaxSelectTarget.setAttribute('src', url.toString());
  }
}
